// LeadFollowupHistory.js
import axios from "axios";
import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import SKAlerts, { CreateAlert } from "../../shared/common-alerts/SKAlerts";
import moment from "moment";
import DatePicker from "react-datepicker";
import { getApiBaseUrl } from "../../utils/apiConfig";
import { getStorageValues } from "../../shared/CommonFunctions";

const LeadFollowupHistory = forwardRef(({ data }, ref) => {
    const [alert, setAlert] = useState(null);
    const [followupList, setFollowupList] = useState([]);
    const [followupDate, setFollowupDate] = useState(new Date());
    const [remarks, setRemarks] = useState("");
    const [showButtons, setShowButtons] = useState(false);

    // expose method to refresh after saving
    useImperativeHandle(ref, () => ({
        refreshFollowup: fetchFollowups
    }));

    async function fetchFollowups() {
        try {
            const params = {
                UserId: getStorageValues("userId"),
                LeadId: data.ClientLeadId,
            };

            const res = await axios.get(
                getApiBaseUrl() + "/getLeadFolloupByLeadId",
                { params }
            );

            if (res.status === 200) {
                setFollowupList(res.data.data[0]);
            }
        } catch (err) {
            CreateAlert("Problem loading follow-up", "Error", setAlert);
        }
    }

    async function saveFollowup() {
        try {
            const payload = {
                UserId: getStorageValues("userId"),
                LeadId: data.ClientLeadId,
                FollowupDate: moment(followupDate).format("YYYY-MM-DD HH:mm:ss"),
                FollowupRemarks: remarks
            };

            const res = await axios.post(getApiBaseUrl() + "/saveLeadFollowup", payload);

            if (res.status === 200) {
                setRemarks("");
                fetchFollowups();
                CreateAlert("Follow-up saved!", "Success", setAlert);
            }
        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchFollowups();
    }, []);

    return (
        <>
            <SKAlerts alert={alert} />

            <div className="row" style={{ margin: '10px 10px 0px 10px' }}>
                {/* Input part */}
                <div className="col-lg-3">
                    <label className="form-label">Follow-up Date</label>
                    <DatePicker
                        className="form-control"
                        selected={followupDate}
                        onChange={(date) => setFollowupDate(date)}
                        minDate={new Date()}
                    />
                </div>

                <div className="col-lg-9">
                    <label className="form-label">Remarks</label>
                    <textarea
                        className="form-control"
                        rows="1"
                        value={remarks}
                        onChange={(e) => setRemarks(e.target.value)}
                        onFocus={() => setShowButtons(true)}
                        placeholder="Add follow-up details..."
                    ></textarea>

                    {showButtons && (
                        <div className="mt-2">
                            <button className="btn btn-primary btn-sm me-2" onClick={saveFollowup}>
                                Save
                            </button>
                            <button
                                className="btn btn-outline-secondary btn-sm"
                                onClick={() => {
                                    setRemarks("");
                                    setShowButtons(false);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </div>

                {/* Display previous follow-ups */}
                <div className="col-12">
                    <div className="scrollable-comments">
                        {followupList?.map((f, i) => (
                            <div className="card card-bg-light mg-em" key={f.LeadFollowupId || i}>
                                <div className="card-body" style={{ margin: '5px 5px 0px 5px' }}  >
                                    <div className="d-flex">
                                        <div className="me-3">
                                            <span className="avatar avatar-rounded">
                                                <img
                                                    alt=""
                                                    src={`/assets/img/profiles/${f.UserImagePath}`}
                                                />
                                            </span>
                                        </div>
                                        <div>
                                            <div className="fw-semibold">{f.FullName}</div>
                                            <div dangerouslySetInnerHTML={{ __html: f.FollowupRemarks }}></div>
                                            <small className="text-muted">
                                                {moment(f.CreatedDate).format("MM/DD/YYYY, h:mm A")}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
});

export default LeadFollowupHistory;
